var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('EmailFormInput'),_vm._v(" "),_c('p',[_vm._v("To be able to start an investigation we'll need 2 photos. Please upload them here")]),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"photo1","id":"photo1","required":_vm.required}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"photo2","id":"photo2"}}),_vm._v(" "),_c('SubmitButton',{attrs:{"btnText":"Submit Enquiry"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb84662a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DamagedForm.vue
// module id = 114
// module chunks = 0